import React from 'react'
import { dispatchAppEvent } from '../../../../lib/events'
import { useQuickAddShortcut } from '../../../../hooks/useQuickAddShortcut'
import { acceleratorLesbar } from '../../../common/preferences/primitives/ShortcutInput'
import { WithTooltip } from '../../../ui/tooltip'
import { PlusIcon } from '../icons/PlusIcon'

// Ein Ereignis statt eines Rückrufs: Die Titelleiste steht über `MainLayout`, das die Schnelleingabe hält.
const openQuickAdd = () => dispatchAppEvent('open-quick-add')

/** Das Kürzel im Tooltip, wie es auf der Tastatur steht. Ohne globales Kürzel (Web, abgeschaltet) bleibt `Q`. */
export function quickAddShortcutText(accelerator: string | null, mac: boolean): string {
  return accelerator ? acceleratorLesbar(accelerator, mac) : 'Q'
}

/**
 * **„+“ für die Schnelleingabe** (#256, Variante A aus `tools/quick-add-button-prototype`): direkt hinter der
 * Lupe, gleich groß und neutral wie sie. Der Tooltip nennt das eingestellte Kürzel.
 *
 * @example
 * <QuickAddButton label={t('titlebar.quickAdd')} mac={platform === 'darwin'} />
 */
export const QuickAddButton = React.memo(({ label, mac }: { label: string; mac: boolean }) => {
  const { shortcut } = useQuickAddShortcut()
  return (
    <WithTooltip content={label} shortcut={{ kind: 'character', text: quickAddShortcutText(shortcut, mac) }} side="bottom">
      <button className="titlebar__quick-add" onClick={openQuickAdd} aria-label={label} data-intro-anchor="quickadd">
        <PlusIcon />
      </button>
    </WithTooltip>
  )
})
